import React, { useState } from 'react';
import EditorAnchor from '@wix/da-ds/pkg/Icons/24x24/EditorAnchor';
import { ButtonProps } from './types';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import { TOOLTIP_HOVER_DELAY } from '../../../constants';
import PromptModal from '@wix/da-ds/pkg/modals/dsPresets/PromptModal';
import EditorIconButton from '../_partials/EditorIconButton';

const LinkAnchor: React.FC<ButtonProps> = ({
  editor,
  hideWhenNotEnabled = true,
}) => {
  const { t } = useTranslation('editor');
  const [isOpen, setIsOpen] = useState(false);

  if (
    !editor.isEditable ||
    (hideWhenNotEnabled && !isExtensionInstalled(editor, 'anchor'))
  ) {
    return null;
  }
  return (
    <>
      {isOpen && (
        <PromptModal
          isOpen
          title={t('ext.anchor.prompt.title')}
          onCancel={() => {
            editor.chain().focus();
            setIsOpen(false);
          }}
          onDone={v => {
            editor
              .chain()
              .focus()
              .setAnchor(v ?? '')
              .run();
            setIsOpen(false);
          }}
          inputPlaceholder={t('ext.anchor.prompt.placeholder')}
          doneButtonLabel={t('ext.anchor.prompt.ok')}
          onInputValidate={v => {
            let invalid = false;
            editor.state.doc.descendants(node => {
              if (node.type.name === 'anchor') {
                if (node.attrs.id === v) {
                  invalid = true;
                  return false;
                }
              }
            });
            return invalid ? t('ext.anchor.prompt.error.dupeId') : undefined;
          }}
        />
      )}
      <EditorIconButton
        featureId="format:anchor"
        tooltipHoverDelay={TOOLTIP_HOVER_DELAY}
        tooltipText={t('button.anchor.tooltip')}
        aria-label={t('button.anchor.tooltip')}
        icon={EditorAnchor}
        onClick={() => {
          setIsOpen(true);
        }}
      />
    </>
  );
};
LinkAnchor.displayName = 'LinkAnchor';

export default LinkAnchor;
